import { useShoppingCartPrice } from '~/domains/cart/queries';
import { BigSaleLabel } from '~/domains/plusMembership/components/BigSale/BigSaleLabel';
import { IS_BIG_SALE } from '~/domains/plusMembership/constants';
import { useMembershipStatus } from '~/domains/plusMembership/hooks/useMembershipStatus';
import { usePlusMembershipEvent } from '~/domains/plusMembership/queries';

import { MembershipWhiteAndGreen28x14Icon } from '~/assets/icons';

// 플멤위크 기간 & 스탠다드, 스탠다드 + 보너스팩 가입자에게 할인이 적용되고 있음을 알려줌
export function MembershipDiscountBanner() {
  const { data } = usePlusMembershipEvent();
  const { planDetail } = useMembershipStatus();
  const { data: shoppingCartPriceData } = useShoppingCartPrice('SHOPPING_CART');

  const { type, description } = shoppingCartPriceData?.banner || {};

  const bigSalePromotionDescription =
    type === 'PLUS_MEMBERSHIP_WEEK'
      ? description
      : '스탠다드 멤버십 5% 중복할인 적용';

  if (!data?.event || planDetail?.planGrade !== 'STANDARD') return null;

  return IS_BIG_SALE ? (
    <div className="flex items-center justify-center gap-8 bg-bigSale-background py-8 text-bigSale-text typo-paragraph100-semibold">
      <BigSaleLabel /> {bigSalePromotionDescription}
    </div>
  ) : (
    <div className="flex items-center justify-center gap-8 py-12 text-gray-000 typo-paragraph200-semibold bg-plusmembership-event-badge">
      <MembershipWhiteAndGreen28x14Icon /> 쿠폰 + 멤버십 5% 중복할인이
      적용되었어요
    </div>
  );
}
